import React, { useEffect, useRef, useState } from 'react';
import { withRouter } from "react-router-dom";

import HeaderV2 from '../../components/headerV2';
import ViewMap from '../../components/novo-produtores/mapView';
import TreatedArea from '../../components/nova-home/treated-area';
import CropManagement from '../../components/nova-home/crop-management';
import FunctionBlockedOverlay from "../../components/functionBlocked";
import Modal from "../../components/modal/modalFuncaoBloqueadaImpressaoFe";

import * as S from './styles';
import ListaProdutores from '../../components/novo-produtores/ListaProdutores';
import CalendaryWeatherForecast from '../../components/nova-home/calendary';

export const compendioG = "@compendioG";

const USER = JSON.parse(localStorage.getItem("@userinfo"));

const isFunctionBlocked = (user) => {
    const planId = user?.contrato?.agro_plan_config?.agro_plan_id;
    const diasRestante = Number(user?.contrato?.dias_restante ?? 0);
    return (
        planId === 7 ||
        planId === 6 ||
        planId === 4 ||
        (planId === 1 && diasRestante <= 0)
    );
};

const NovoProdutores = ({ ...props }) => {
    const [coordenadas, setCoordenadas] = useState({latitude: "", longitude: ""})
    const [openModalTrue, setOpenModalTrue] = useState(false);

    const weatherMapBlockedRef = useRef(null);
    const treatedAreaBlockedRef = useRef(null);

    const isBlocked = isFunctionBlocked(USER);

    return (
        <S.Container>
            <HeaderV2 title="Produtores"/>
            
            <S.Wrapper>
                <S.ContentPage>
                    <ListaProdutores />
                </S.ContentPage>

                <S.SecontContentPage>
                    <S.Background style={{ position: "relative" }}>
                        <div style={{ display: "flex", width: "100%" }}>
                            <div style={{ display: "flex", flexDirection: "row" }}>
                                <CalendaryWeatherForecast updateCoordinates={(e) => setCoordenadas(e)}/>
                            </div>

                            <S.MapView>
                                <ViewMap coordenadas={coordenadas}/>
                            </S.MapView>
                        </div>

                        {isBlocked && (
                            <>
                                <div ref={weatherMapBlockedRef} style={{ position: "absolute", inset: 0 }} />

                                <FunctionBlockedOverlay
                                    visible
                                    mode="cover-parent"
                                    attachTo={weatherMapBlockedRef}
                                    ctaType="activate"
                                    onActivate={() => setOpenModalTrue(true)}
                                />
                            </>
                        )}
                    </S.Background>
                </S.SecontContentPage>

                <S.ThirdyContentPage>
                    {isBlocked ? (
                        <>
                            <div ref={treatedAreaBlockedRef} style={{ width: "100%" }}>
                                <TreatedArea />
                            </div>

                            <FunctionBlockedOverlay
                                visible
                                mode="cover-parent"
                                attachTo={treatedAreaBlockedRef}
                                ctaType="activate"
                                onActivate={() => setOpenModalTrue(true)}
                            />
                        </>
                    ) : (
                        <TreatedArea />
                    )}

                    <CropManagement />
                </S.ThirdyContentPage>
            </S.Wrapper>

            {openModalTrue ? (
                <Modal show={openModalTrue} onHide={() => setOpenModalTrue(false)} />
            ) : null}
        </S.Container>
    );
};

export default withRouter(NovoProdutores);